import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { DECOR_MENU, decorSlugLabel } from "@/data/homeDecor";

/**
 * Sprint 28 · Home Décor hub directory.
 * Rendered inside CategoryDetail for the "home-decor" category — groups all
 * 26 home-décor sourcing category pages by family. Purely additive: the
 * existing category content, SEO title/meta and schema stay untouched.
 */
export const HomeDecorFamilies = () => (
  <section
    className="wrap hd-families"
    style={{ paddingBlock: "var(--section)" }}
    data-testid="home-decor-families"
  >
    <Reveal as="p" className="eyebrow">The home décor library</Reveal>
    <Reveal
      as="h2"
      className="display"
      style={{ fontSize: "var(--t-h1)", margin: "1rem 0 1.2rem", lineHeight: 1.05 }}
    >
      Twenty-six categories, seven families — one QC chain.
    </Reveal>
    <Reveal
      as="p"
      style={{ color: "var(--ink-soft)", maxWidth: "64ch", fontSize: "1.05rem" }}
    >
      Every category below is a complete sourcing programme — supplier verification,
      product development, sampling, AQL inspection and export documentation —
      mapped to the Indian clusters that actually make it. Start with a family,
      or send one brief across several.
    </Reveal>

    {DECOR_MENU.map((g, gi) => (
      <div key={g.id} className="hd-family" data-testid={`hd-family-${g.id}`}>
        <Reveal className="hd-family-head">
          <span className="mono hd-family-ix">/ {String(gi + 1).padStart(2, "0")}</span>
          <h3 className="hd-family-title">{g.label}</h3>
          <span className="mono hd-family-count">
            {g.items.length} {g.items.length === 1 ? "category" : "categories"}
          </span>
        </Reveal>
        <div className="hd-family-grid">
          {g.items.map((c) => (
            <Reveal key={c.slug}>
              <Link
                to={`/categories/home-decor/${c.slug}`}
                className="hd-card"
                data-testid={`hd-card-${c.slug}`}
              >
                <span className="hd-card-kw">{c.primaryKeyword}</span>
                <span className="hd-card-name">{decorSlugLabel(c.slug)}</span>
                <span className="hd-card-arrow">Explore →</span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    ))}
  </section>
);

export default HomeDecorFamilies;
